import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

/**
 * Page press and media detail search mapper
 * extracts searchable content from page content type "pagePressAndMediaDetail"
 *
 * @param {Object} context - page data context
 * @return {String} - searchable content
 */
export default (context) => {
  let result = ''
  const content = context.data.content

  // title
  if (content.title) {
    result += `${content.title} `
  }

  // introText
  if (content.introText) {
    result += `${documentToPlainTextString(content.introText.json)} `
  }

  // text
  if (content.text) {
    result += `${documentToPlainTextString(content.text.json)} `
  }

  return result
}
